<template>
  <v-dialog
    v-model="dialog"
    width="916"
    open-on-focus
    no-click-animation
    persistent
    content-class="gif-picker-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-toolbar
        flat
        height="76"
      >
        <v-toolbar-title class="gif-picker-toolbar-title">Add gif</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-combobox
          :value="oldSearchPhrase"
          :search-input.sync="searchPhrase"
          :items="(autocompleteData.data || []).map(el => el.name)"
          class="bh-input-pill rounded-pill"
          background-color="bhGray6"
          height="48px"
          append-icon="bhi-loupe"
          placeholder="Search gifs..."
          cache-items
          hide-no-data
          clearable
          hide-details
          @input="runSearch"
          @click:clear="clearSearch"
          @click:append="runSearch"
          @keydown.enter="runSearch"
          solo
          flat
          filled
        ></v-combobox>
        <v-btn
          color="accent"
          icon
          tile
          @click="closeDialog"
        >
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="gif-picker-container">
        <v-overlay :value="loading" z-index="4">
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
        <v-container>
          <v-row class="text-center giphy-powered">
            <v-col class="d-flex justify-center align-center">
              <span class="giphy-powered__text bhGray1--text">Powered by GIPHY</span> <img src="@/assets/giphyLogo.png" class="giphy-powered__logo" />
            </v-col>
          </v-row>
          <v-row v-masonry="masonryGrid">
            <v-col v-for="(gif, index) in gifsToRender" :key="index + gif.id" @click="chooseFile(gif)" cols="12" sm="4">
              <v-img
                :src="gif.images.preview_webp.url"
                :aspect-ratio="gif.images.preview_webp.width / gif.images.preview_webp.height"
                @load="showDialog ? $redrawVueMasonry(masonryGrid) : null"
                class="giphy__file"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="accent lighten-2"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col>
              <v-btn
                elevation="0"
                color="accent"
                rounded
                @click="searchMore"
              >Load more
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import * as giphy from '../../helpers/giphy';

export default {
  name: 'GifPickerDialog',
  components: {
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      gif: null,
      searchPhrase: '',
      oldSearchPhrase: '',
      searchTagsTimeout: null,
      gifs: {},
      trendingGifs: {},
      autocompleteData: {},
      masonryGrid: null
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
        setTimeout(() => {
          this.$redrawVueMasonry(this.masonryGrid)
        }, 500);
      } else {
        this.gifs = {};
        this.searchPhrase = '';
        this.oldSearchPhrase = '';
        this.dialog = false
      }
    },
    searchPhrase: function(val) {
      clearTimeout(this.searchTagsTimeout);
      this.searchTagsTimeout = null;
      this.autocompleteData = {};

      if (val !== this.oldSearchPhrase) {
        this.searchTagsTimeout = setTimeout(() => {
          this.searchTags(val);
        }, 350);
      }
    }
  },
  computed: {
    gifsToRender() {
      const { oldSearchPhrase, gifs, trendingGifs } = this;

      return oldSearchPhrase
        ? (gifs.data || [])
        : (trendingGifs.data || []);
    }
  },
  created() {
    this.searchGifs({});
  },
  methods: {
    closeDialog () {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    async searchGifs ({ offset = null, search = null }) {
      console.log({search,offset})
      const { oldSearchPhrase, searchPhrase, gifs } = this;
      search = (search === null ? searchPhrase : search) || '';
      offset = (offset === null ? (gifs.data || []).length : offset) || 0;

      this.loading = true;

      if (search) {
        const newGifs = await giphy.searchGifs({ offset, q: search });
        console.log('oldSearchPhrase = search');
        this.oldSearchPhrase = search;

        if (search === oldSearchPhrase) {
          this.gifs = {
            ...newGifs,
            data: [
              ...this.gifs.data || [],
              ...newGifs.data
            ]
          };
        } else {
          this.gifs = { ...newGifs };
        }

        this.loading = false;
      } else {
        this.searchTrendingGifs({ offset });
      }
    },
    async searchTrendingGifs ({ offset }) {
      const { trendingGifs } = this;
      this.oldSearchPhrase = '';
      this.searchPhrase = '';
      offset = (offset === null ? (trendingGifs.data || []).length : offset) || 0;

      if (offset >= (trendingGifs.data || []).length) {
        const newGifs = await giphy.getTrendingGifs({ offset });

        this.trendingGifs = {
          ...newGifs,
          data: [
            ...this.trendingGifs.data || [],
            ...newGifs.data
          ]
        };
      }

      this.loading = false;
    },
    async searchTags (text) {
      if (!text) {
        this.autocompleteData = {};

        return;
      }

      try {
        const autocomplete = await giphy.searchTags({ q: text });
        this.autocompleteData = autocomplete;
      } catch (error) {
        this.autocompleteData = {};
      }
    },
    clearSearch () {
      this.searchPhrase = '';
      this.oldSearchPhrase = '';
    },
    runSearch () {
      const { oldSearchPhrase, searchPhrase, gifs, trendingGifs } = this;

      const offset = searchPhrase
        ? (gifs.data || []).length
        : (trendingGifs.data || []).length;

      this.searchGifs({ search: searchPhrase, offset });
    },
    chooseFile(data) {
      this.$emit('gif-picked',data)
    },
    searchMore() {
      const { gifs, searchPhrase, trendingGifs, loading } = this;

      if (!loading) {
        this.searchGifs({
          offset: (searchPhrase ? (gifs?.data || []).length : (trendingGifs?.data || []).length) || 0,
          search: searchPhrase
        });
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.gif-picker {
  &-container {
    background:$bh-white;
    padding: 0 0.75*$gutter;
    height: 100%;
    overflow: auto;
  }
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: calc(100% - 76px); // 76px is height of v-toolbar in v-dialog header
    max-height: calc(100% - #{2*$gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
    }
    .bhi-loupe {
      transform: none !important;
    }
    .giphy__file {
      cursor: pointer;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
}
.giphy-powered {
  &__logo {
    margin-left: 8px;
  }
}
</style>
